import axios from 'axios';
import { getV7MicroServiceUrl } from '../helpers/helpers';
import { generalData } from './general';
export const addToOrder = (id) => ({
  type: 'ADD_TO_ORDER',
  id,
});
export const resetOrder = () => ({
  type: 'RESET',
});

export const removeFromOrder = (id) => ({
  type: 'REMOVE_FROM_ORDER',
  id,
});
export const getAddresses = (postcode) => ({
  type: 'GET_ADDRESSES',
  payload: axios.get(
    `${getV7MicroServiceUrl('business-freepack')}freepack/address/${postcode}`,
  ),
});
export const getFreeProducts = (providerSlug) => {
  return {
    type: 'GET_FREE_PRODUCTS',
    payload: axios.get(
      `${getV7MicroServiceUrl('business-freepack')}freepack/products/${providerSlug}`,
    ),
  };
};

export const submitOrder = (data, onSuccess, onFailed) => {
  return (dispatch) => {
    const response = dispatch({
      type: 'SUBMIT_ORDER',
      payload: axios.post(
        `${getV7MicroServiceUrl('business-freepack')}freepack/checkout`,
        data,
      ),
    });

    response
      .then((resp) => {
        console.log(resp);
        dispatch(generalData());
        onSuccess();
      })
      .catch((err) => {
        console.log(err);
        onFailed();
      });
  };
};

export const clearAddress = () => ({
  type: 'CLEAR_ADDRESS',
});

export const persistDetails = (details) => ({
  type: 'PERSIST_DETAILS',
  details,
});
export const preCheckout = (data) => ({
  type: 'PRE_CHECKOUT',
  payload: axios.post(
    `${getV7MicroServiceUrl('business-freepack')}freepack/pre-checkout`,
    data,
  ),
});
